import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Facebook, Instagram } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="min-h-screen bg-atomic-black" data-id="element-632">
      {/* Compact Hero Section */}
      <section className="relative py-8 md:py-12 overflow-hidden bg-gradient-to-br from-atomic-charcoal via-atomic-black to-atomic-black" data-id="element-633">
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(rgba(163, 230, 53, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(163, 230, 53, 0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }} data-id="element-634" />

        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-635">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="max-w-3xl mx-auto text-center" data-id="element-636">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-3 leading-tight" data-id="element-637">
              Request Pricing or{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-atomic-green to-lime-400" data-id="element-638">
                Help With Your Order
              </span>
            </h1>

            <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-639">
              Use this form for pricing questions, custom projects, or order
              help. For DTF transfers, the fastest option is our online builder.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Form + Info */}
      <section className="py-12 bg-atomic-black" data-id="element-640">
        <div className="container mx-auto px-4 md:px-6" data-id="element-641">
          <div className="max-w-6xl mx-auto" data-id="element-642">
            <div className="grid lg:grid-cols-3 gap-12" data-id="element-643">
              {/* Contact Info Sidebar */}
              <div className="lg:col-span-1" data-id="element-644">
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} className="space-y-8" data-id="element-645">
                  <div data-id="element-646">
                    <h2 className="text-2xl font-bold text-white mb-6" data-id="element-647">
                      Contact Info
                    </h2>

                    <div className="space-y-4" data-id="element-648">
                      <div className="flex items-start gap-3" data-id="element-649">
                        <div className="w-10 h-10 rounded-lg bg-atomic-green/10 flex items-center justify-center text-atomic-green border border-atomic-green/20 flex-shrink-0" data-id="element-650">
                          <MapPin size={20} data-id="element-651" />
                        </div>
                        <div data-id="element-652">
                          <h3 className="text-sm font-bold text-white mb-1" data-id="element-653">
                            Location
                          </h3>
                          <p className="text-sm text-gray-400" data-id="element-654">
                            320 Main Street
                            <br data-id="element-655" />
                            Morrice, MI 48857
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-3" data-id="element-656">
                        <div className="w-10 h-10 rounded-lg bg-atomic-green/10 flex items-center justify-center text-atomic-green border border-atomic-green/20 flex-shrink-0" data-id="element-657">
                          <Phone size={20} data-id="element-658" />
                        </div>
                        <div data-id="element-659">
                          <h3 className="text-sm font-bold text-white mb-1" data-id="element-660">
                            Phone
                          </h3>
                          <a href="tel:517-414-9232" className="text-sm text-gray-400 hover:text-atomic-green transition-colors" data-id="element-661">
                            517-414-9232
                          </a>
                        </div>
                      </div>

                      <div className="flex items-start gap-3" data-id="element-662">
                        <div className="w-10 h-10 rounded-lg bg-atomic-green/10 flex items-center justify-center text-atomic-green border border-atomic-green/20 flex-shrink-0" data-id="element-663">
                          <Mail size={20} data-id="element-664" />
                        </div>
                        <div data-id="element-665">
                          <h3 className="text-sm font-bold text-white mb-1" data-id="element-666">
                            Email
                          </h3>
                          <a href="mailto:info@printatomic.com" className="text-sm text-gray-400 hover:text-atomic-green transition-colors" data-id="element-667">
                            info@printatomic.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Social Media */}
                  <div data-id="element-668">
                    <h3 className="text-lg font-bold text-white mb-4" data-id="element-669">
                      Follow Us
                    </h3>
                    <div className="flex gap-3" data-id="element-670">
                      <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-atomic-charcoal border border-white/10 flex items-center justify-center text-gray-400 hover:text-atomic-green hover:border-atomic-green/50 transition-colors" data-id="element-671">
                        <Facebook size={20} data-id="element-672" />
                      </a>
                      <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-atomic-charcoal border border-white/10 flex items-center justify-center text-gray-400 hover:text-atomic-green hover:border-atomic-green/50 transition-colors" data-id="element-673">
                        <Instagram size={20} data-id="element-674" />
                      </a>
                    </div>
                  </div>

                  {/* Business Hours */}
                  <div className="bg-atomic-charcoal rounded-xl p-6 border border-white/10" data-id="element-675">
                    <h3 className="text-lg font-bold text-white mb-4" data-id="element-676">
                      Business Hours
                    </h3>
                    <div className="space-y-2 text-sm" data-id="element-677">
                      <div className="flex justify-between" data-id="element-678">
                        <span className="text-gray-400" data-id="element-679">Monday - Friday</span>
                        <span className="text-white" data-id="element-680">9am - 5pm</span>
                      </div>
                      <div className="flex justify-between" data-id="element-681">
                        <span className="text-gray-400" data-id="element-682">Saturday</span>
                        <span className="text-white" data-id="element-683">By Appointment</span>
                      </div>
                      <div className="flex justify-between" data-id="element-684">
                        <span className="text-gray-400" data-id="element-685">Sunday</span>
                        <span className="text-white" data-id="element-686">Closed</span>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>

              {/* Contact Form */}
              <div className="lg:col-span-2" data-id="element-687">
                <motion.div initial={{
                opacity: 0,
                x: 20
              }} animate={{
                opacity: 1,
                x: 0
              }} className="bg-atomic-charcoal rounded-xl p-8 border border-white/10" data-id="element-688">
                  <h2 className="text-2xl font-bold text-white mb-6" data-id="element-689">
                    Request a Quote
                  </h2>

                  <form onSubmit={handleSubmit} className="space-y-6" data-id="element-690">
                    <div className="grid md:grid-cols-2 gap-6" data-id="element-691">
                      <div data-id="element-692">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-693">
                          Name *
                        </label>
                        <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 bg-atomic-black border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-atomic-green transition-colors" placeholder="Your name" data-id="element-694" />
                      </div>

                      <div data-id="element-695">
                        <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-696">
                          Email *
                        </label>
                        <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 bg-atomic-black border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-atomic-green transition-colors" placeholder="your@email.com" data-id="element-697" />
                      </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-6" data-id="element-698">
                      <div data-id="element-699">
                        <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-700">
                          Phone
                        </label>
                        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 bg-atomic-black border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-atomic-green transition-colors" placeholder="(555) 123-4567" data-id="element-701" />
                      </div>

                      <div data-id="element-702">
                        <label htmlFor="company" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-703">
                          Company / Team
                        </label>
                        <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-3 bg-atomic-black border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-atomic-green transition-colors" placeholder="Your company or team name" data-id="element-704" />
                      </div>
                    </div>

                    <div data-id="element-705">
                      <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-706">
                        Project Details *
                      </label>
                      <textarea id="message" name="message" required rows={6} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 bg-atomic-black border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-atomic-green transition-colors resize-none" placeholder="Tell us about your project: what you need, quantity, timeline, etc." data-id="element-707" />
                    </div>

                    <Button type="submit" size="lg" className="w-full md:w-auto" data-id="element-708">
                      Submit Quote Request
                    </Button>
                  </form>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}